import { Device } from "src/app/interfaces";
import { ModularFieldPayload, RegisterTechFormValues, RegisterUserFormValues, TechRouteSelections, TripType } from "../interfaces";
import { VisitorRegistrationBeforeModularFormField } from "../interfaces/register-user.response";
import { TYPE_OF_REGISTER_MODULAR_FORM_FIELD } from "../components/register-user-form/config";
import { toCountryAnswer } from "../utils/country-answer";

export const registerUserFormAdapter = (
  device: Device,
  formValue: RegisterUserFormValues,
  modularFieldDefinitions: VisitorRegistrationBeforeModularFormField[] = [],
): any => {
  const payload: any = {
    client_id: device.client || device.distributorID,
    client_type: device.type,
    app_id: device.appID,
    startDate: formValue.startDate,
    endDate: formValue.endDate,
    startLocation: formValue.startLocationAddress,
    tripType: Array(String((formValue.tripType as unknown as TripType).id)),
    categories: formValue.categories,
    subdomain: formValue.subdomain,
    app: formValue.subdomain,
    coordinates: `${formValue.startLocationLat}` + "," + `${formValue.startLocationLng}`,
  }

  if (formValue.startTime) {
    payload.startTime = formValue.startTime;
  }

  if (typeof formValue.search_radius_km === 'number') {
    payload.search_radius_km = formValue.search_radius_km;
  }

  const modularFields: ModularFieldPayload[] = [];

  modularFieldDefinitions.forEach((field, index) => {
    const key = `${field.type}_${index}`;
    const value = formValue[key];
    if (value == null) return;

    // El país viaja como iata (ES, PT…), que es lo que el CMS guarda y filtra.
    const answer: unknown = field.type === TYPE_OF_REGISTER_MODULAR_FORM_FIELD.country
      ? toCountryAnswer(value)
      : value;

    modularFields.push({
      // Las preguntas de texto traen su titular en `name`, no en `title`.
      question: field.title || field.name || field.type,
      type: field.type,
      answer,
      required: field.required,
    });
  });

  if (modularFields.length > 0) {
    payload.modularFields = modularFields;
  }

  return payload;
};

export const registerTechFormAdapter = (
  formValue: RegisterTechFormValues,
  techSelections: TechRouteSelections,
): any => {
  return {
    techMode: true,
    points: techSelections.points,
    events: techSelections.events,
    startDate: formValue.startDate,
    endDate: formValue.endDate,
    startLocation: formValue.startLocationAddress,
    subdomain: formValue.subdomain,
    app: formValue.subdomain,
    coordinates: `${formValue.startLocationLat}` + "," + `${formValue.startLocationLng}`,
  };
};